import type { PersonalDataItemViewModel } from '@trinnvis/dabih-api-client';

export function networkHasPersonalDataItems(n: {
  computers: { personalDataItems: PersonalDataItemViewModel[] }[];
}): boolean {
  return n.computers.filter((c) => c.personalDataItems.length > 0).length > 0;
}
